<template>
    <div class="room_component">
        <el-drawer title="额度管理" :visible.sync="isShow" size="900px" @close="$emit('close')">
            <el-form :inline="true" :model="searchForm" size="small" ref="searchForm" @keyup.enter.native="handleSearch"
                label-width="70px">
                <el-form-item label="时间" prop="selectTime">
                    <el-date-picker v-model="selectTime" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd" :clearable="false"
                        key="picker1" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"  style="width: 230px"
                        @change="handleChangeDate"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
                    <el-button @click="handleReset" size="small">重置</el-button>
                </el-form-item>
            </el-form>
            <div style="padding-bottom: 10px">
                <el-button type="primary" size="small" @click="handleEditCredit">修改额度</el-button>
                <el-button type="success" size="small" @click="handleChargeAmount">充值</el-button>
                <el-button type="success" size="small" @click="handleSettleAmount">结算账单</el-button>
            </div>

            <div class="total-card">
                <div class="card-item">
                    <span>可用余额(元)</span>
                    <p>{{ totalData.amount || 0 }}</p>
                </div>
                <div class="card-item">
                    <span>信用额度(元)</span>
                    <p>{{ totalData.totalCredit || 0 }}</p>
                </div>
                <div class="card-item">
                    <span>已用额度(元)</span>
                    <p>{{ totalData.usedAmount || 0 }}</p>
                </div>
                <div class="card-item">
                    <span>剩余额度(元)</span>
                    <p>{{ totalData.creditAmount || 0 }}</p>
                </div>
                <div class="card-item">
                    <span>月结欠款(元)</span>
                    <p>{{ totalData.monthDept || 0 }}</p>
                </div>
            </div>

            <el-table border size="small" style="width: 100%; margin-top: 10px" :data="tableData" v-loading="isLoading"
                element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)">
                <el-table-column type="index" label="排序" align="center"></el-table-column>
                <el-table-column prop="createTime" label="时间" width="170"></el-table-column>
                <el-table-column prop="phone" label="手机号" width="120"></el-table-column>
                <el-table-column prop="transactType" label="交易类型" width="100">
                    <template slot-scope="{ row }">
                        <el-tag type="danger" size="mini">{{ row.transactTypeDesc }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="type" label="资金类型" width="100">
                    <template slot-scope="{ row }">
                        <el-tag type="danger" size="mini">{{ row.typeDesc }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="changeAmount" label="变动金额" width="150"></el-table-column>
                <el-table-column prop="creditAmount" label="剩余额度(元)" width="150"></el-table-column>
                <el-table-column prop="amount" label="可用余额(元)" width="150"></el-table-column>
                <el-table-column prop="monthDept" label="月结欠款(元)" width="150"></el-table-column>
                <el-table-column prop="detail" label="详情" width="200"></el-table-column>
                <el-table-column label="操作" fixed="right" width="120">
                    <template slot-scope="{ row }">
                        <el-button size="mini" type="text" @click="handleShowDetail(row)">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleChangeSize" @current-change="handleChangePage"
                style="text-align:right;margin-top:10px;" :current-page="searchForm.pageNumber" :page-sizes="[10, 20, 50]"
                :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </el-drawer>

        <el-dialog :visible.sync="isCharge" title="充值" width="500px" append-to-body destroy-on-close :close-on-press-escape="false" :close-on-click-modal="false">
            <div class="warm-tips">
               <i class="el-icon-info"></i>
                <span>企业预存金额系统将依据已完成的订单进行自动扣除，无需手动结算</span>
            </div>
            <el-form ref="modelForm" :model="modelForm" label-width="110px" style="margin: 0 20px" size="small" :rules="modelFormRules">
                
                <el-form-item label="剩余余额(元)" prop="creditAmount">
                    <el-input v-model="modelForm.creditAmount" disabled style="width: 250px"></el-input>
                </el-form-item>
               
                <el-form-item label="充值金额(元)" prop="amount">
                    <el-input v-model="modelForm.amount" placeholder="请输入充值金额" style="width: 250px"></el-input>
                </el-form-item>

                <el-form-item label="充值凭证" prop="expectImage">
                    <el-upload class="image-uploader image-uploader1" action="/room/upload/img" :headers="headers" name="mulFile"
                         :data="{ key: 'head' }" :show-file-list="false"
                         :on-success="handleAvatarSuccess"
                         :before-upload="beforeAvatarUpload">
                         <img v-if="modelForm.expectImage" :src="modelForm.expectImage" class="avatar">
                         <div v-else class="image-uploader-icon">
                              <i class="el-icon-plus"></i>
                              <span>上传图片</span>
                         </div>
                         <div slot="tip" class="el-upload__tip"
                              style="width: 250px;line-height: 20px;font-size: 11px;color: #999999;">支持jpg .jpeg
                              .png格式，大小不超过5M，最多上传1张</div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button type="text" @click="isCharge = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmit('modelForm')">提交</el-button>
            </div>
        </el-dialog>

        <!-- 结算账单 -->
        <el-dialog :visible.sync="isSettle" title="结算账单" width="530px" append-to-body destroy-on-close :close-on-press-escape="false" :close-on-click-modal="false">
            <div class="warm-tips" v-if="!modelForm.id">
               <i class="el-icon-info"></i>
               <div>
                    <span>1.企业预存金额系统将依据已完成的订单进行自动扣除，无需手动结算</span>
                    <span>2.授权信用额度消费和月结需要完成结算后，恢复可用额度与欠款清零</span>
               </div>
            </div>
            
            <el-form ref="modelForm" :model="modelForm" label-width="120px" style="margin: 0 20px" size="small" :rules="modelFormRules">
                <!-- <el-form-item label="已用余额(元)" prop="creditAmount">
                    <el-input v-model="modelForm.creditAmount" disabled style="width: 250px"></el-input>
                </el-form-item> -->
                <el-form-item label="已用额度(元)" prop="usedAmount" v-if="modelForm.type == 0">
                    <el-input v-model="modelForm.usedAmount" disabled style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="月结欠款(元)" prop="creditAmount" v-if="modelForm.type == 1">
                    <el-input v-model="modelForm.monthDept" disabled style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="结算金额(元)" prop="settlementAmount">
                    <el-input v-model="modelForm.settlementAmount" placeholder="请输入结算金额" style="width: 250px"></el-input>
                </el-form-item>
               
            </el-form>
            <div slot="footer">
                <el-button type="text" @click="isSettle = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submitLoading" @click="handleConfirm('modelForm')">提交</el-button>
            </div>
        </el-dialog>

        <!-- 详情 -->
        <el-dialog :visible.sync="isStatement" title="详情" width="800px" append-to-body destroy-on-close :close-on-press-escape="false" :close-on-click-modal="false">
            
            <div v-if="detailForm.orderNo">
                <el-form ref="detailForm" inline :model="detailForm" label-width="90px" size="small">
                    <div class="legend-title">基本信息</div>
                    <el-form-item label="预定时间" prop="createTime">
                        <el-input v-model="detailForm.createTime" disabled style="width: 230px"></el-input>
                    </el-form-item>
                    <el-form-item label="订单号" prop="orderNo">
                        <el-input v-model="detailForm.orderNo" disabled style="width: 230px"></el-input>
                    </el-form-item>
                    <el-form-item label="预订用户" prop="username">
                        <el-input v-model="detailForm.username" disabled style="width: 230px"></el-input>
                    </el-form-item>
                    <el-form-item label="支付方式" prop="payWayDesc">
                        <el-input v-model="detailForm.payWayDesc" disabled style="width: 230px"></el-input>
                    </el-form-item>
                    <el-form-item label="姓名" prop="customerName">
                        <el-input v-model="detailForm.customerName" disabled style="width: 230px"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="customerMobile">
                        <el-input v-model="detailForm.customerMobile" disabled style="width: 230px"></el-input>
                    </el-form-item>
                
                </el-form>
                <div class="legend-title">订单信息</div>
                <el-table border size="small" style="width: 100%; margin-top: 10px" :data="[detailForm]">
                    <el-table-column prop="hotelName" label="酒店名称" width="230" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="days" label="预定天数" width="100"></el-table-column>
                    <el-table-column prop="roomTypeName" label="房型" width="100"></el-table-column>
                    <el-table-column prop="roomQty" label="房间数" width="100"></el-table-column>
                    <el-table-column prop="lastPay" label="支付金额(元)" width="100"></el-table-column>
                    <el-table-column prop="discount" label="优惠(元)" width="100"></el-table-column>
                    <el-table-column prop="estimatedCheckIn" label="入住时间" width="120"></el-table-column>
                    <el-table-column prop="estimatedCheckOut" label="退房时间"  width="120"></el-table-column>
                </el-table>
            </div>
            <div v-if="transactType == 1">
                <el-form ref="detailForm" inline :model="detailForm" label-width="100px" size="small">
                    <el-form-item label="充值详情">
                        <el-input v-model="detailForm.detail" disabled style="width: 230px"></el-input>
                    </el-form-item>
                    <el-form-item label="充值时间">
                        <el-input v-model="detailForm.createTime" disabled style="width: 230px"></el-input>
                    </el-form-item>
                    <el-form-item label="充值金额(元)" prop="changeAmount">
                        <el-input v-model="detailForm.changeAmount" disabled style="width: 230px"></el-input>
                    </el-form-item>
                    <el-form-item label="充值凭证" prop="expectImage">
                        <el-image  style="width: 120px; height: 90px" :src="detailForm.expectImage"  :preview-src-list="[detailForm.expectImage]"></el-image>
                    </el-form-item>
                
                </el-form>
            </div>

            <div v-if="transactType == 4">
                <el-form ref="detailForm" inline :model="detailForm" label-width="100px" style="margin: 0 20px" size="small">
                <el-form-item label="剩余余额(元)" prop="amount">
                    <el-input v-model="detailForm.amount" disabled style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item label="剩余额度(元)" prop="creditAmount" v-if="detailForm.type == 0">
                    <el-input v-model="detailForm.creditAmount" disabled style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item label="月结欠款(元)" prop="monthDept" v-if="detailForm.type == 2">
                    <el-input v-model="detailForm.monthDept" disabled style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item label="结算金额(元)" prop="changeAmount">
                    <el-input v-model="detailForm.changeAmount" disabled style="width: 230px"></el-input>
                </el-form-item>
               
            </el-form>
            </div>
            <div slot="footer" style="margin: 0 20px; text-align: right">
                <el-button type="primary" @click="isStatement = false">关闭</el-button>
            </div>
        </el-dialog>

        <AddEditComponent :isShow="isEdit" @close="isEdit=false" :id="propsData.id" @confirm="getCreditDetail"/>
   </div>
</template>


<script>
import _ from "lodash";
import AddEditComponent from "../addEditComponent/index.vue";
export default {
    components: {
        AddEditComponent
    },
    props: {
        isDetail: {
            type: Boolean,
            default: false,
        },
        propsData: {
            type: Object,
            default: {},
        },
    },
    computed: {
        headers() {
            return {
                "Authorization": localStorage.getItem('Token'),
            }
        },
    },
    data() {
        const validateCredit = (rule, value, callback) => {
            if (!value || !/^\d+(\.\d{1,2})?$/.test(value)) {
                callback(new Error("充值金额不能为空且只能保留两位小数"));
            } else {
                callback();
            }
        };

        const validateAmount = (rule, value, callback) => {
            if (!value || !/^\d+(\.\d{1,2})?$/.test(value)) {
                callback(new Error("结算金额不能为空且只能保留两位小数"));
            } else {
                callback();
            }
        };
        return {
            totalData: {},
            isShow: false,
            searchForm: {
                refResourceId: this.propsData.id,
                startDate: "",
                endDate: "",
                pageSize: 10,
                pageNumber: 1,
            },
            selectTime: "",
            isLoading: false,
            tableData: [],
            total: 0,

            isEdit: false,

            isCharge: false,
            modelForm: {},
            modelFormRules: {
                amount: [{ required: true, validator: validateCredit, trigger: "blur" }],
                settlementAmount: [{ required: true, validator: validateAmount, trigger: "blur" }],
            },
            submitLoading: false,

            isSettle: false,
            detailForm: {},
            isStatement: false,
            transactType: ""
        }
    },
    watch: {
        isDetail(newVal) {
            this.isShow = !!newVal;
            if (!!newVal) {
                this.searchForm = {
                    refResourceId: this.propsData.id,
                    startDate: "",
                    endDate: "",
                    pageSize: 10,
                    pageNumber: 1,
                };

                this.getRecordList();
                this.getCreditDetail();
            }
        },
    },
    methods: {
        handleShowDetail(item) {
            this.transactType = item.transactType;
            if(item.refOrderId) {
                this.getRequest(`/api/order/getByOrderNo?orderNo=${item.refOrderId}`)
                .then(res => {
                    let data = res.data;
                    if (data.code == 200) {
                        this.detailForm = data.data;
                        this.isStatement = true;
                    }
                })
            } else {
                this.detailForm = _.cloneDeep(item);
                this.isStatement = true;   
            }
        },
        handleConfirm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitLoading = true;
                    this.postRequest("/enterCredit/settlement", this.modelForm)
                        .then((res) => {
                            this.submitLoading = false;
                            let data = res.data;
                            if (data.code == 200) {
                                this.$message.success(data.msg);
                                this.isSettle = false;
                                this.getRecordList();
                                this.getCreditDetail();
                            }
                        })
                        .catch(() => {
                            this.submitLoading = false;
                        });
                    
                }
            });
        },
        handleSubmit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitLoading = true;
                    this.postRequest("/enterCredit/rechargeAmount", this.modelForm)
                        .then((res) => {
                            this.submitLoading = false;
                            let data = res.data;
                            if (data.code == 200) {
                                this.$message.success(data.msg);
                                this.isCharge = false;
                                this.getRecordList();
                                this.getCreditDetail();
                            }
                        })
                        .catch(() => {
                            this.submitLoading = false;
                        });
                    
                }
            });
        },
        handleAvatarSuccess(res) {
            this.modelForm.expectImage = res.data;
        },
        beforeAvatarUpload(file) {
            const isJPG = (file.type === 'image/jpeg') || (file.type === 'image/jpe') || (file.type === 'image/png');
            const isLt2M = file.size / 1024 / 1024 < 5;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG/JPEG/PNG 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 5MB!');
            }
            return isJPG && isLt2M;
        },
        handleSettleAmount() {
            this.modelForm = _.cloneDeep(this.totalData);
            this.modelForm.settlementAmount = "";
            this.isSettle = true;
        },
        handleChargeAmount() {
            this.modelForm = _.cloneDeep(this.totalData);
            this.modelForm.amount = "";
            this.modelForm.expectImage = "";
            this.isCharge = true;
        },
        handleEditCredit() {
            this.isEdit = true;
        },
        handleSearch() {
            this.searchForm.pageNumber = 1;
            this.getRecordList();
            this.getCreditDetail();
        },

        handleReset() {
            this.searchForm = {
                refResourceId: this.propsData.id,
                startDate: "",
                endDate: "",
                pageSize: 10,
                pageNumber: 1,
            };
            this.selectTime = null;
            this.getRecordList();
        },
        handleChangeDate(date) {
            if (date.length) {
                this.searchForm.startDate = date[0];
                this.searchForm.endDate = date[1];
            }
        },

        handleChangePage(page) {
            this.searchForm.pageNumber = page;
            this.getRecordList();
        },

        handleChangeSize(size) {
            this.searchForm.pageNumber = 1;
            this.searchForm.pageSize = size;
            this.getRecordList();
        },
        getRecordList() {
            this.isLoading = true;
            this.getRequest("/enterCreditChange/getPage", this.searchForm).then((res) => {
                let data = res.data;
                this.isLoading = false;
                if (data.code == 200) {
                    this.tableData = data.data.records;
                    this.total = data.data.total;
                }
            });
        },
        getCreditDetail() {
            this.isEdit = false;
            this.getRequest(`/enterCredit/getDetail?id=${this.propsData.id}`).then((res) => {
                let data = res.data;
                this.isLoading = false;
                if (data.code == 200) {
                    this.totalData = data.data;
                }
            });  
        }
    },
}
</script>

<style>
    .total-card {
        padding: 20px 30px;
        background-color: #EBF1FF;
        display: flex;
        justify-content: space-around;
        text-align: center;
        font-size: 13px;
        color: #666;
        margin: 15px 0;

    }

    .total-card  p {
        font-size: 14px;
        font-weight: bold;
        padding-top: 15px;
    }
</style>